/**
 * Vue 3 composable for navigation utilites.
 *
 * @author crm4f
 */
import { useRouter } from "vue-router"

export const useNavUtils = () => {

  const router = useRouter()
  
  const go = (path) => {
    router.push(path).catch((err) => {
      const errstr = err.toString()
      if (!errstr.startsWith('NavigationDuplicated')) {
        // NavigationDuplicated: user clicked on the highlighted icon which is the current screen so ignore
        console.log(err)
      }
    })
  }

  return {
    // return defined consts and methods here
    go
  }
}
  